import React, { useEffect, useState } from "react";
import { AuthProvider } from "oidc-react";
import Report from "./components/Report";
import "./App.css";


function App() {
 
  const [config, setConfig] = useState(null);
  const [language, setLanguage] = useState("en");
  const [navigationData, setNavigationData] = useState(null);

  useEffect(() => {
    fetch(`/Navigation-${language}.json`)
      .then((res) => res.json())
      .then((data) => setNavigationData(data))
      .catch(() => setNavigationData(null));
  }, [language]);

  useEffect(() => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("token_expiry");
    fetch(`${process.env.PUBLIC_URL}/Config.json`)
      .then((res) => res.json())
      .then(setConfig)
      .catch((err) => console.error("Config load error:", err));
  }, []);

  if (!config) return <div>Loading configuration...</div>;

  return (
    <AuthProvider
      authority={config.Authority}
      clientId={config.ClientId}
      redirectUri={config.RedirectUri}
      responseType={config.ResponseType}
      scope={config.Scope}
      onSignIn={() => {
        // Redirect to root without query params
        window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
      }}
      automaticSilentRenew={false}
    >    
      <Report config={config} navigationData={navigationData} language={language} setLanguage={setLanguage} />
      </AuthProvider>
  );
}

export default App;
